export default __webpack_public_path__ + "static/media/GooglePlay.aca20897.svg";